<template>
  <div class="mainContainer" v-loading='mainLoading'>
    <div class="nav" v-if="pageType == 0">
      <div class="navContainer" style="width: 240px">
        <p>运输方式：</p>
        <el-select v-model="queryCriteria.transportType" size="mini" filterable style="width: 150px" placeholder="请选择运输方式">
          <el-option v-for="item in transportTypeOption" :key="item.label" :label="item.label" :value="item.value" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 240px">
        <p>计划类型：</p>
        <el-select v-model="queryCriteria.planType" size="mini" filterable style="width: 150px" placeholder="请选择计划类型">
          <el-option v-for="item in planTypeOption" :key="item.label" :label="item.label" :value="item.value" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 400px">
        <p>年/月：</p>
        <el-input v-model="queryCriteria.startYearMonth" size="mini" style="width: 150px" placeholder="请输入年/月" />
        <span style="margin: 0 10px;"> - </span>
        <el-input v-model="queryCriteria.endYearMonth" size="mini" style="width: 150px" placeholder="请输入年/月" />
      </div>
      <div class="navContainer" style="width: 210px">
        <p>标题：</p>
        <el-input v-model="queryCriteria.title" size="mini" style="width: 150px" placeholder="请输入标题" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>锁定状态：</p>
        <el-select v-model="queryCriteria.lockedState" size="mini" filterable style="width: 150px" placeholder="请选择锁定状态">
          <el-option v-for="item in lockedStateOption" :key="item.label" :label="item.label" :value="item.value" />
        </el-select>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="onSearchBtni">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" @click="addBtn">新增</el-button>
        <el-button size="small" type="danger" @click="onClickDeletes">批量删除</el-button>
        <el-button size="small" class="searchBtn" @click="setLockingBtn">锁定/解锁</el-button>
      </div>
    </div>
    <div class="content" v-if="pageType == 0">
      <div class="tableContainer">
        <el-table
          ref="tableRef"
          v-loading="tableLoad"
          :data="tableDatas"
          style="width: 100%"
          row-key="id"
          border
          :header-cell-style="{
            color: '#3B3B3B',
            'font-size': '13px',
            height: '48px',
            background: '#E8E8E8',
          }"
          :cell-style="{ color: '#7F7F7F', 'font-size': '13px', height: '52px' }"
          @selection-change="selectionChange"
          :row-style="rowStyle">
          <el-table-column type="selection" align="center" width="55" :reserve-selection="true"></el-table-column>
          <el-table-column label="序号" align="center" type="index" width="50px" />
          <el-table-column label="运输方式" prop="transportType" width="150px" align="center">
            <template slot-scope="scope">
              {{ scope.row.transportType == 1?'水路/水陆联运':'公路' }}
            </template>
          </el-table-column>
          <el-table-column label="计划类型" prop="planType" width="150px" align="center">
            <template slot-scope="scope">
              {{ scope.row.planType == 1?'年度计划':'月度计划' }}
            </template>
          </el-table-column>
          <el-table-column label="年/月" prop="yearMonths" width="150px" align="center"></el-table-column>
          <el-table-column label="标题" prop="title" width="150px" align="center"></el-table-column>
          <el-table-column label="锁定状态" prop="lockedState" width="150px" align="center">
            <template slot-scope="scope">
              {{ scope.row.lockedState == 1?'已锁定':'未锁定' }}
            </template>
          </el-table-column>
          <el-table-column label="创建人" prop="creator" width="150px" align="center"></el-table-column>
          <el-table-column label="创建时间" prop="createTime" width="150px" align="center"></el-table-column>
          <el-table-column label="操作" min-width="260" align="center">
            <template slot-scope="scope">
              <div>
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row)" style="margin-bottom: 10px;">详情</el-button>
                <el-button v-if="scope.row.lockedState == 0" size="mini" class="yellow-bg" type="primary" @click="changeClick(scope.row)">修改</el-button>
                <el-button v-if="scope.row.lockedState == 0" size="mini" type="danger" @click="deleteClick(scope.row.id)">删除</el-button>
                <el-button v-if="scope.row.lockedState == 0" size="small" type="primary" @click="onClickLocking(scope.row)">锁定</el-button>
                <el-button v-if="scope.row.lockedState == 1" size="small" type="primary" @click="onClickUnlock(scope.row)">解锁</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{ total }}条</span>
        <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="sizes,prev, pager, next,jumper" :total="total" @size-change="contractSizeChange" @current-change="contractCurrentChange" @prev-click="contractCurrentChange" @next-click="contractCurrentChange" />
      </div>
    </div>
    <WaterwayOrIntermodalTransportation v-if="pageType == 1" :planId="planId" @setPageType = "setPageType" />
    <highway v-if="pageType == 2" :planId="planId" @setPageType = "setPageType" />
    <!-- 新增 -->
    <el-dialog :title="addTitle" :visible.sync="addDialogVisible" width="550px" center @close="dialogClose" :close-on-click-modal="false">
      <div class="depart">
        <el-form :model="addData" :rules="addRules" ref="addRuleForm" label-position="left">
          <el-form-item label="运输方式：" prop="transportType" style="margin-left: 100px;">
            <el-radio-group v-model="addData.transportType">
              <el-radio :label="1">水路/水陆联运</el-radio>
              <el-radio :label="2">公路</el-radio>
            </el-radio-group>
          </el-form-item>
          <div style="display: flex; align-items: center; margin-left: 100px;">
            <el-radio-group v-model="addData.planType" @change="handleChangeYearMonth" size="small" style="margin-bottom: 10px; margin-right: 30px;">
              <el-radio-button label="1">年</el-radio-button>
              <el-radio-button label="2">月</el-radio-button>
            </el-radio-group>
            <el-form-item :label="addData.planType==1?'年：':'月：'" prop="yearMonths" label-width="40px">
              <el-input v-model="addData.yearMonths" size="mini" :placeholder="addData.planType==1?'请选择年':'请选择月'" style="width: 160px" />
            </el-form-item>
          </div>
          
          <el-form-item label="标题：" prop="title" style="margin-left: 100px;">
            <el-input v-model="addData.title" size="mini" placeholder="请输入标题" style="width: 260px" />
          </el-form-item>
          <div class="btnContainer">
            <el-button class="searchBtn" size="small" @click="onAddSure">确认</el-button>
            <el-button class="resetBtn" size="small" @click="addDialogVisible = false">关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import WaterwayOrIntermodalTransportation from './components/WaterwayOrIntermodalTransportation.vue';
  import highway from './components/highway.vue';

  import { yearMonthPlanAddAll, yearMonthPlanList, yearMonthPlanAllLockingAll, yearMonthPlanAllDeleteAll, yearMonthPlanUpdateAll } from '@/service/vehiclelog';

  export default {
    components: { WaterwayOrIntermodalTransportation, highway },
    data() {
      return {
        planId: '',
        pageType: 0, // 0主页面 - 1水路/水陆联运 - 2公路
        mainLoading: false,
        queryCriteria: {
          transportType: '', // 运输方式
          planType: '', // 计划类型
          startYearMonth: '', // 年月
          endYearMonth: '', // 年月
          title: '', // 标题
          lockedState: '', // 锁定状态
        },
        tableLoad: false,
        tableDatas: [], // 表格数据
        checkTableData: [],
        page: 1,
        rows: 10,
        total: 0,
        addDialogVisible: false,
        addTitle: '',
        addData: {
          id: '',
          transportType: '',
          planType: '1',
          yearMonths: '',
          title: '',
        },
        addRules: {},
        transportTypeOption: [
          { label: '全部', value: '' },
          { label: '水路/水陆联运', value: 1 },
          { label: '公路', value: 2 },
        ],
        planTypeOption: [
          { label: '全部', value: '' },
          { label: '年度计划', value: 1 },
          { label: '月度计划', value: 2 },
        ],
        lockedStateOption: [
          { label: '全部', value: '' },
          { label: '已锁定', value: 1 },
          { label: '未锁定', value: 0 },
        ],
      }
    },
    methods: {
      setPageType(type) {
        this.pageType = type;
      },
      onSearchBtni() {
        this.page = 1;
        this.onSearchBtn();
      },
      async onSearchBtn() {
        this.tableLoad = true;
        const {status, message, data} = await yearMonthPlanList({
          ...this.queryCriteria,
          page: this.page,
          rows: this.rows,
        });
        if (status !== 0) return this.$message.error(message);
        this.total = data.total;
        this.tableDatas = data.records;
        this.tableLoad = false;
      },
      resetBtn() {},
      addBtn() {
        this.addData = {
          id: '',
          transportType: '',
          planType: '1',
          yearMonths: '',
          title: '',
        };
        this.addTitle = '新增';
        this.addDialogVisible = true;
      },
      onClickDeletes() {
        this.$confirm('此操作将永久删除选中数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const {status, message} = await yearMonthPlanAllDeleteAll({ids: this.checkTableData.map(item => item.id).join(',')})
          if (status !== 0) return this.$message.error(message);
          this.$message.success(message);
          this.page = 1;
          this.onSearchBtn();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      },
      async setLockingBtn() {
        if (this.checkTableData.length > 0) {
          const {status, message} = await yearMonthPlanAllLockingAll({ids: this.checkTableData.map(item => item.id).join(','), type: this.getLockedStatei(this.checkTableData[0]['lockedState'])});
          if (status !== 0) return this.$message.error(message);
          this.$message.success(message);
          this.onSearchBtn();
        } else {
          this.$message.error("请至少选择一条数据！");
        }
        
      },
      getLockedStatei(type) {
        if (type == 1) {
          return 0;
        } else {
          return 1;
        }
      },
      selectionChange(rows) {
        this.checkTableData = rows;
      },
      contractSizeChange(sizes) {
        this.rows = sizes;
        this.page = 1;
        this.onSearchBtn();
      },
      contractCurrentChange(page) {
        this.page = page;
        this.onSearchBtn();
      },

      detailClick(row) {
        // if (row.transportType == 1)
        this.pageType = row.transportType;
        this.planId = row.id;
      },
      changeClick(row) {
        this.addData = row;
        this.addTitle = '修改';
        this.addDialogVisible = true;
      },
      deleteClick(id) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const {status, message} = await yearMonthPlanAllDeleteAll({ids: id})
          if (status !== 0) return this.$message.error(message);
          this.$message.success(message);
          this.page = 1;
          this.onSearchBtn();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      },
      async onClickLocking(row) {
        const {status, message} = await yearMonthPlanAllLockingAll({ids: row.id, type: 1});
        if (status !== 0) return this.$message.error(message);
        this.$message.success(message);
        this.onSearchBtn();
      },
      async onClickUnlock(row) {
        const {status, message} = await yearMonthPlanAllLockingAll({ids: row.id, type: 0});
        if (status !== 0) return this.$message.error(message);
        this.$message.success(message);
        this.onSearchBtn();
      },

      async onAddSure() {
        let statusi, messagei;
        if (this.addTitle == '新增') {
          const { status, message } = await yearMonthPlanAddAll(this.addData);
          statusi = status;
          messagei = message;
        } else {
          const { status, message } = await yearMonthPlanUpdateAll(this.addData);
          statusi = status;
          messagei = message;
        }
        // const { status, message } = await yearMonthPlanAddAll(this.addData);
        if (statusi !== 0) return this.$message.error(messagei);
        this.$message.success(messagei);
        this.page = 1;
        this.onSearchBtn();
        this.addDialogVisible = false;
      },
      dialogClose() {},
      handleChangeYearMonth(event) {
        this.addData.yearMonths = '';
      },

      rowStyle({ row }) {
        return this.checkTableData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
    },
  }
</script>

<style lang="scss" scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainer {
        margin-bottom: 25px;
        width: 100%;

        ::v-deep {
          .el-badge__content {
            top: 4px !important;
            right: 1px !important;
          }

          .el-badge__content {
            background-color: #f56c6c !important;
          }

          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;
      max-height: 80vh;
      overflow: auto;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          &Item {
            margin-bottom: 20px;

            ::v-deep {
              .el-table td,
              .el-table th {
                padding: 0;
              }

              .cell {
                font-size: 10px;
                padding: 0;
              }
            }

            .imgContainer {
              display: flex;
              align-items: center;
            }

            .span1 {
              font-weight: 700;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        ::v-deep {
          .el-table td,
          .el-table th {
            padding: 0;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }
    }
  }
</style>
